/* eslint-disable */
const requestAnimationFrameFun =
  window.requestAnimationFrame ||
  (window as any).mozRequestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  (window as any).msRequestAnimationFrame ||
  ((fn: Function) => {
    setTimeout(() => {
      fn.call(null, Number(new Date()));
    }, 16);
  });

export const Quad_easeIn = (t: number, b: number, c: number, d: number) =>
  c * (t /= d) * t + b;
export const Quad_easeInOut = (t: number, b: number, c: number, d: number) => {
  if ((t /= d / 2) < 1) return (c / 2) * t * t + b;
  return (-c / 2) * (--t * (t - 2) - 1) + b;
};
export const Quad_easeOut = (t: number, b: number, c: number, d: number) =>
  -c * (t /= d) * (t - 2) + b;
export interface IScrollOption {
  duration?: number;
  curve?: (t: number, b: number, c: number, d: number) => number;
}
export default class SmoothScroll {
  $el: HTMLElement;
  duration: number;
  curve: (t: number, b: number, c: number, d: number) => number;
  isDoc = false;
  constructor(el: HTMLElement | Document, options?: IScrollOption) {
    if (el instanceof Document) {
      this.$el = el.documentElement;
      this.isDoc = true;
    } else {
      this.$el = el;
    }
    options = options || {};
    this.duration = options.duration || 400;
    this.curve = options.curve || Quad_easeIn;
  }
  scrollTo(end: number, ptime?: number) {
    const scrollTop = this.getScrollTop();
    const time = ptime || this.duration;
    const b = scrollTop;
    const c = end - b;
    const d = time || this.duration;
    let start: null | number = null;

    return new Promise((resolve, reject) => {
      const step = (timeStamp: number) => {
        if (start === null) start = timeStamp;
        const progress = timeStamp - start;
        if (progress < time) {
          const st = this.curve(progress, b, c, d);
          this.setScrollTop(st);
          // this.$el.scrollTop = st;
          requestAnimationFrameFun(step);
        } else {
          this.setScrollTop(end);
          // this.$el.scrollTop = end;
          resolve(end);
        }
      };
      requestAnimationFrameFun(step);
    });
  }
  scrollToElem = (elem: HTMLElement, time?: number, offset?: number) => {
    const top = elem.getBoundingClientRect().top + this.getScrollTop();
    const position = top - (offset || 0);
    return this.scrollTo(position, time);
  };
  scrollToTop() {
    return this.scrollTo(0);
  }
  scrollToBottom(time?: number, offset?: number) {
    let top = this.$el.scrollHeight;
    const cHeight = this.isDoc ? window.innerHeight : this.$el.clientHeight;
    top = top - cHeight;
    if (offset) {
      top = top - offset;
    }
    return this.scrollTo(top, time);
  }
  getScrollTop() {
    if (this.isDoc) {
      return document.body.scrollTop + document.documentElement.scrollTop;
    }
    return this.$el.scrollTop;
  }
  setScrollTop(p: number) {
    if (this.isDoc) {
      document.body.scrollTop = p;
      document.documentElement.scrollTop = p;
    } else {
      this.$el.scrollTop = p;
    }
  }
}
